import(/* webpackMode: "eager" */ "/www/app/apps/client/app/global-error.tsx");
